import { type RefObject, useRef } from "react"

import { type QueryKey, type UseQueryResult, useQuery } from "@tanstack/react-query"
import { AxiosError } from "axios"
import isEmpty from "lodash-es/isEmpty"

import { ESocialLoginQueryKey } from "@/3514/config"
import { socialLoginQueryFetcher } from "@/3514/fetchers"
import type { IJwtTokenPairDto, IJwtTokenPairModel } from "@/models/jwt"

type TSocialLoginQuery = UseQueryResult<IJwtTokenPairModel, AxiosError>

function useSocialLoginQuery(): TSocialLoginQuery {
    const jwtAuthUrl: RefObject<string> = useRef<string>(JSAPP_CONF.jwt_pair_url ?? String())

    return useQuery<IJwtTokenPairDto, AxiosError, IJwtTokenPairModel, QueryKey>({
        queryKey: ESocialLoginQueryKey(),
        queryFn: socialLoginQueryFetcher,
        notifyOnChangeProps: ["data", "isSuccess"],
        staleTime: 0,
        gcTime: 0,
        networkMode: "offlineFirst",
        throwOnError: false,
        enabled: !isEmpty(jwtAuthUrl.current)
    })
}

export { useSocialLoginQuery }
export type { TSocialLoginQuery }
